// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 368) return "static/chunks/b8fbd430-2991e5ffd95098d5.js";
	if (chunkId === 86) return "static/chunks/86-e7ededcb6f669cbb.js";
	if (chunkId === 11) return "static/chunks/11-1e27b6bc392b7456.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"112":"layout__minimal","136":"datadog_browser_logs","687":"datadog_browser_rum","818":"layout__client_site_chrome_ui"}[chunkId] || chunkId) + "." + {"112":"194716ddc7aaf8ad","136":"433aea6f4a21f1e4","365":"44bcbbe10280b852","648":"d127c6b5c9f4b91b","687":"f209dc1d55c13309","739":"20536efac026971f","818":"fa11f89056677f18"}[chunkId] + ".js";
};